<template>
   <div class="search_box">
    <slot></slot>
    <div class="flex">
      <span class="btn search_btn" @click="subSearch" >查询</span>
      <span class="btn clear_btn" @click="subClear">重置</span>
     <!-- <button class="btn search_btn" @click="subSearch">搜索</button>
      <button class="btn clear_btn" @click="subClear">清空条件</button> -->
    </div>
   </div>
</template> 

<script>
export default{
  props:{
    fromData:Object
  },
  data(){
    return{
    }
  },
  methods:{
    //搜索
    subSearch(){
      this.$emit('subSearch');
    },
    //清空
    subClear(){
      this.fromData.searchCriteria = {}; 
      this.fromData.resourceName = '';     
      this.$emit('subClear');
    }
  }
}
</script>

<style>
</style>
